(function () {
  if (window.__unipacCartAutoSyncInstalled) return;
  window.__unipacCartAutoSyncInstalled = true;

  let refreshTimer = null;
  let refreshing = false;
  let queued = false;

  /*
   * ONLY watch ADD TO CART.
   *
   * Removing items and changing quantities
   * are already handled properly by cart-items.js.
   */
  function isCartAddUrl(url) {
    try {
      const parsed = new URL(
        url,
        window.location.origin
      );

      return /\/cart\/add(?:\.js)?$/.test(
        parsed.pathname
      );
    } catch (error) {
      return false;
    }
  }

  /*
   * Detect the free-gift add request.
   *
   * We do NOT want this script opening/rebuilding
   * the drawer when cart-gift.js adds a gift.
   */
  function isGiftRequest(body) {
    if (!body) return false;

    if (typeof body === 'string') {
      return body.includes('_cart_gift');
    }

    if (body instanceof FormData) {
      for (const [key, value] of body.entries()) {
        if (
          String(key).includes('_cart_gift') ||
          String(value).includes('_cart_gift')
        ) {
          return true;
        }
      }
    }

    return false;
  }

  async function refreshAfterAdd(opener = null) {
    if (refreshing) {
      queued = true;
      return;
    }

    refreshing = true;

    try {
      const drawer =
        document.querySelector('cart-drawer');

      if (!drawer) return;

      const drawerSection =
        drawer.closest('.shopify-section');

      if (!drawerSection) return;

      const drawerSectionId =
        drawerSection.id.replace(
          'shopify-section-',
          ''
        );

      const sectionIds = [
        drawerSectionId,
        'cart-icon-bubble'
      ];

      const url =
        new URL(window.location.href);

      url.search = '';

      url.searchParams.set(
        'sections',
        sectionIds.join(',')
      );

      url.searchParams.set(
        '_cart_add_refresh',
        Date.now().toString()
      );

      const response =
        await fetch(
          url.toString(),
          {
            method: 'GET',
            headers: {
              Accept: 'application/json'
            },
            cache: 'no-store'
          }
        );

      if (!response.ok) {
        throw new Error(
          `Cart refresh failed: ${response.status}`
        );
      }

      const sections =
        await response.json();

      /*
       * Let the theme render the freshly
       * returned cart HTML.
       */
      if (
        typeof drawer.renderContents ===
        'function'
      ) {
        await drawer.renderContents(
          { sections },
          false
        );
      }

      /*
       * Open drawer after product is added.
       */
      if (
        typeof drawer.open === 'function'
      ) {
        drawer.open(
          opener ||
          document.activeElement ||
          null
        );
      }

      /*
       * Tell the gift system:
       * cart changed, recalculate now.
       */
      document.dispatchEvent(
        new CustomEvent(
          'on:cart:change',
          {
            detail: {
              source: 'cart-add'
            }
          }
        )
      );

    } catch (error) {
      console.error(
        'Cart add refresh error:',
        error
      );
    } finally {
      refreshing = false;

      if (queued) {
        queued = false;

        setTimeout(() => {
          refreshAfterAdd();
        }, 50);
      }
    }
  }

  function scheduleRefresh(opener = null) {
    clearTimeout(refreshTimer);

    /*
     * Open drawer immediately so customer
     * gets instant feedback.
     */
    const drawer =
      document.querySelector('cart-drawer');

    if (
      drawer &&
      typeof drawer.open === 'function'
    ) {
      drawer.open(
        opener ||
        document.activeElement ||
        null
      );
    }

    /*
     * Then retrieve the actual updated cart.
     */
    refreshTimer =
      setTimeout(() => {
        refreshAfterAdd(opener);
      }, 120);
  }

  /*
   * =====================================================
   * FETCH
   * =====================================================
   */

  const originalFetch =
    window.fetch;

  window.fetch =
    async function (...args) {
      const input = args[0];
      const options = args[1] || {};

      const url =
        typeof input === 'string'
          ? input
          : input instanceof Request
            ? input.url
            : String(input);

      const isAdd =
        isCartAddUrl(url);

      const giftRequest =
        isAdd &&
        isGiftRequest(options.body);

      const response =
        await originalFetch.apply(
          this,
          args
        );

      if (
        isAdd &&
        response.ok &&
        !giftRequest
      ) {
        scheduleRefresh(
          document.activeElement
        );
      }

      return response;
    };

  /*
   * =====================================================
   * XHR FALLBACK
   * =====================================================
   */

  const originalOpen =
    XMLHttpRequest.prototype.open;

  const originalSend =
    XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open =
    function (
      method,
      url,
      ...rest
    ) {
      this.__unipacCartAdd =
        isCartAddUrl(url);

      return originalOpen.call(
        this,
        method,
        url,
        ...rest
      );
    };

  XMLHttpRequest.prototype.send =
    function (body) {
      const giftRequest =
        this.__unipacCartAdd &&
        isGiftRequest(body);

      if (
        this.__unipacCartAdd &&
        !giftRequest
      ) {
        this.addEventListener(
          'loadend',
          () => {
            if (
              this.status >= 200 &&
              this.status < 300
            ) {
              scheduleRefresh(
                document.activeElement
              );
            }
          },
          { once: true }
        );
      }

      return originalSend.call(
        this,
        body
      );
    };
})();